import script from "./Video Square.vue?vue&type=script&setup=true&lang=js"
export * from "./Video Square.vue?vue&type=script&setup=true&lang=js"

import "./Video Square.vue?vue&type=style&index=0&id=90b06790&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.4_vue@3.5.4_webpack@5.94.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-90b06790"]])

export default __exports__